export default __webpack_public_path__ + "static/media/avatar_68.0f7e220a.png";